import { collection, getDocs, addDoc, Firestore, query, where } from 'firebase/firestore';
import { DEFAULT_WORKSTREAM_TYPES } from '../types';

export const migrateDefaultWorkstreamTypes = async (firestore: Firestore, workspaceId: string): Promise<void> => {
  const typesRef = collection(firestore, `workspaces/${workspaceId}/workstreamTypes`);
  
  // Additional safety check - look for specific default types
  for (const defaultType of DEFAULT_WORKSTREAM_TYPES) {
    // Check if this type already exists
    const existingType = await getDocs(
      query(typesRef, where('name', '==', defaultType.name))
    );
    
    // Only add if this specific type doesn't exist
    if (existingType.empty) {
      try {
        await addDoc(typesRef, defaultType);
        console.log(`Added default type: ${defaultType.name}`);
      } catch (error) {
        console.error(`Error adding default type ${defaultType.name}:`, error);
      }
    }
  }
  
  console.log('Default workstream types migration completed');
};